import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  FaFire, FaCompass, FaEnvelope, FaVideo, FaCamera, 
  FaStar, FaEye, FaSignOutAlt, FaHeart, FaUser, FaCog 
} from 'react-icons/fa';
import './sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleNavClick = (e, path) => {
    // Fermer la sidebar sur mobile
    if (window.innerWidth <= 768) {
      onClose();
    }
    
    // Forcer la navigation propre
    navigate(path);
  };

  // Fonction pour vérifier si un lien est actif
  const isActive = (path) => {
    return location.pathname === path;
  };

  const navItems = [
    { path: '/dashboard', icon: FaFire, label: 'Hot Matches', badge: user?.stats?.matches },
    { path: '/discover', icon: FaCompass, label: 'Découvrir' },
    { path: '/messages', icon: FaEnvelope, label: 'Messages', badge: user?.stats?.unreadMessages },
    { path: '/videos', icon: FaVideo, label: 'Vidéos' },
    { path: '/photos', icon: FaCamera, label: 'Photos' },
    { divider: true },
    { path: '/favorites', icon: FaStar, label: 'Mes favoris', badge: user?.stats?.favorites },
    { path: '/visits', icon: FaEye, label: 'Visiteurs', badge: user?.stats?.views },
    { path: '/my-profile', icon: FaUser, label: 'Mon profil' },
  ];

  const getAvatarUrl = () => {
    if (user?.avatar) {
      return `${process.env.REACT_APP_UPLOADS_URL}/${user.avatar}`;
    }
    return 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e';
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      {/* <div className="sidebar-header">
        <div className="logo" onClick={() => handleNavClick(null, '/dashboard')}>
          <FaHeart className="logo-icon" />
          <span>MURIMA</span>
        </div>
      </div> */}

      <div className="user-info">
        <div className="user-avatar" onClick={() => handleNavClick(null, '/my-profile')}>
          <img src={getAvatarUrl()} alt={user?.pseudo || 'Avatar'} />
          <span className="online-badge"></span>
        </div>
        <div className="user-name">{user?.pseudo || 'Utilisateur'}</div>
        <div className="user-status">
          {user?.is_premium ? 'Premium 💎' : 'En ligne 🔥'}
        </div>
      </div>

      <nav className="nav-menu">
        {navItems.map((item, index) => 
          item.divider ? (
            <div key={`divider-${index}`} className="nav-divider" />
          ) : (
            <button
              key={item.path}
              className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
              onClick={(e) => handleNavClick(e, item.path)}
            >
              <item.icon />
              <span>{item.label}</span>
              {item.badge > 0 && <span className="badge">{item.badge}</span>}
            </button>
          )
        )}

        <div className="nav-divider" />

        <button onClick={handleLogout} className="nav-link">
          <FaSignOutAlt />
          <span>Déconnexion</span>
        </button>
      </nav>
    </aside>
  );
};

export default Sidebar;